<div class="card container-fluid" style="flex: 1 0 auto">
  <div class="row justify-content-start" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">{{ titulo }}</h3>
    </div>
  </div>
  <div class="container-fluid justify-content-center">
    <p-stepper [(activeStep)]="active" [linear]="true">
      <p-stepperPanel header="{{ step1_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-center">
            <div class="container offset-md-3">
              <form (ngSubmit)="next()" [formGroup]="formPublicity">
                <div class="row gap-2">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-3">
                      <label for="float-input">Titulo*:</label>
                    </div>
                    <div class="col-12 col-sm-8">
                      <input
                        class="largeInput"
                        type="text"
                        pInputText
                        formControlName="pub_tilte"
                      />
                      <span
                        class="text-danger labelError"
                        *ngIf="
                          formPublicity.controls['pub_tilte'].hasError(
                            'required'
                          ) && formPublicity.controls['pub_tilte'].touched
                        "
                      >
                        Campo Requerido
                      </span>
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-3">
                      <label for="float-input">Descripcion*:</label>
                    </div>
                    <div class="col-12 col-sm-8">
                      <input
                        class="largeInput"
                        type="text"
                        pInputText
                        formControlName="pub_description"
                      />
                      @if (
                        formPublicity.controls["pub_description"].hasError(
                          "required"
                        ) && formPublicity.controls["pub_description"].touched
                      ) {
                        <span class="text-danger labelError">
                          Campo Requerido
                        </span>
                      }
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-3 labelModal">
                      <label for="float-input">Sitio web*:</label>
                    </div>
                    <div class="col-12 col-sm-8">
                      <input
                        class="largeInput"
                        type="text"
                        pInputText
                        formControlName="pub_url_site"
                      />
                      @if (
                        formPublicity.controls["pub_url_site"].hasError(
                          "required"
                        ) && formPublicity.controls["pub_url_site"].touched
                      ) {
                        <span class="text-danger labelError">
                          Campo Requerido
                        </span>
                      }
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-6 col-sm-3 labelModal">
                      <label for="float-input">Fecha de inicio*:</label>
                    </div>
                    <div class="col-6 col-sm-8">
                      <p-calendar
                        formControlName="pub_date_start"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        dateFormat="dd-mm-yy"
                        [minDate]="minDateToday"
                      />
                      @if (
                        formPublicity.controls["pub_date_start"].hasError(
                          "required"
                        ) && formPublicity.controls["pub_date_start"].touched
                      ) {
                        <span class="text-danger labelError">
                          Campo Requerido
                        </span>
                      }
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-3 labelModal">
                      <label for="float-input">Fecha de Fin*:</label>
                    </div>
                    <div class="col-12 col-sm-8">
                      <p-calendar
                        formControlName="pub_date_end"
                        [showIcon]="true"
                        inputId="buttondisplay"
                        [showOnFocus]="false"
                        dateFormat="dd-mm-yy"
                        [minDate]="minDateToday"
                      />

                      @if (
                        formPublicity.controls["pub_date_end"].hasError(
                          "required"
                        ) && formPublicity.controls["pub_date_end"].touched
                      ) {
                        <span class="text-danger labelError">
                          Campo Requerido
                        </span>
                      }
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-3 labelModal">
                      <label for="float-input">Estado*:</label>
                    </div>
                    <div class="col-12 col-sm-8">
                      <p-dropdown
                        [options]="ltsStates"
                        optionLabel="pd_name"
                        optionValue="pd_code"
                        placeholder="Selecciona un estado"
                        formControlName="pub_state_id"
                        appendTo="body"
                      />
                      @if (
                        formPublicity.get("pub_state_id")?.invalid &&
                        formPublicity.get("pub_state_id")?.dirty
                      ) {
                        <span class="text-danger labelError">
                          El campo es requerido
                        </span>
                      }
                    </div>
                  </div>

                  <div class="row rowPad align-items-center">
                    <div class="col-12 col-sm-3">
                      <label for="float-input">Tipo de Publicidad*:</label>
                    </div>
                    <div class="col-12 col-sm-8">
                      <p-dropdown
                        [options]="ltsTypePublicity"
                        optionLabel="typ_name"
                        optionValue="typ_id"
                        placeholder="Selecciona un tipo"
                        formControlName="pub_publicity_type_id"
                        appendTo="body"
                      />
                      @if (
                        formPublicity.get("pub_publicity_type_id")?.invalid &&
                        formPublicity.get("pub_publicity_type_id")?.dirty
                      ) {
                        <span class="text-danger labelError">
                          El campo es requerido
                        </span>
                      }
                    </div>
                  </div>

                  <div class="d-flex pt-4 justify-content-end">
                    <p-button
                      label="Next"
                      icon="pi pi-arrow-right"
                      iconPos="right"
                      type="submit"
                      [disabled]="formPublicity.invalid"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{ step2_titulo }}">
        <ng-template pTemplate="content">
          <div class="d-flex flex-column align-items-center">
            <p-fileUpload
              #fileUpload
              mode="basic"
              chooseLabel="Buscar"
              chooseIcon="pi pi-upload"
              [showUploadButton]="false"
              [showCancelButton]="false"
              [maxFileSize]="1000000"
              (onSelect)="onUploadAuto($event.files, fileUpload)"
              accept="image/*"
              [multiple]="false"
              class="mb-3"
            >
            </p-fileUpload>

            <div
              class="border rounded d-flex flex-column align-items-center justify-content-center p-3"
              style="width: 320px; min-height: 350px"
            >
              @if (document) {
                <p-image
                  [src]="document.filstring"
                  alt="Imagen subida"
                  width="300"
                  height="300"
                />

                <div
                  class="d-flex justify-content-between align-items-center w-100 mt-2"
                >
                  <small class="text-truncate">
                    {{ document.file.name }}
                  </small>

                  <p-button
                    icon="pi pi-times"
                    severity="danger"
                    (onClick)="removeFile()"
                  >
                  </p-button>
                </div>
              } @else {
                <p-image
                  src="assets/images/subir.png"
                  alt="Imagen por defecto"
                  width="300"
                  height="300"
                />
              }
            </div>
          </div>

          <div class="d-flex pt-4 justify-content-between">
            <p-button label="Back" icon="pi pi-arrow-left" (onClick)="back()" />
            <p-button
              label="Guardar"
              icon="pi pi-arrow-right"
              iconPos="right"
              (onClick)="createPublicity()"
            />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{ step3_titulo }}">
        <ng-template pTemplate="content">
          <div
            class="border rounded d-flex flex-column align-items-center justify-content-center p-3"
          >
            <div class="row p-2">
              <p-image
                src="assets/images/ok.png"
                alt="Imagen por defecto"
                width="300"
                height="300"
              />
            </div>
            <span>Publicidad creada correctamente</span>
            <div class="row p-2">
              <p-button
                label="Lista de Publicidades"
                icon="pi pi-bars"
                routerLink="/admin/publicity"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </div>
</div>
